import { BookmakerName } from '@/constants';
import type { CustomerPlItem } from '@/models/customerPl';
import { eventPeriodDictionary } from '@/stores/simpleDictionary/eventPeriod';
import { eventTypeDictionary } from '@/stores/simpleDictionary/eventType';
import { leagueLimitsCategoryDictionary } from '@/stores/simpleDictionary/leagueLimitsCategory';
import { marketTypeDictionary } from '@/stores/simpleDictionary/marketType';
import { sportDictionary } from '@/stores/simpleDictionary/sport';
import type { CustomerPlSection } from '@/types/customerPl';

export function resolveCustomerPlDisplayName(item: CustomerPlItem, section: CustomerPlSection): string {
    if (section === 'total') {
        if (item.name && item.groupNameId != null) {
            return `${item.name} (#${item.groupNameId})`;
        }
        return item.name || '';
    }

    if (item.groupNameId == null) return '';

    switch (section) {
        case 'sport':
            return sportDictionary.nameById(item.groupNameId) || '';
        case 'periodType':
            return eventPeriodDictionary.nameById(item.groupNameId) || '';
        case 'marketType':
            return eventTypeDictionary.nameById(item.groupNameId) || '';
        case 'market':
            return marketTypeDictionary.nameById(item.groupNameId) || '';
        case 'bookmaker':
            return BookmakerName[item.groupNameId] || '';
        case 'leagueLimits':
            return leagueLimitsCategoryDictionary.nameById(item.groupNameId) || '';
        case 'customLeague':
            return `${item.groupName} (#${item.groupNameId})`;
        default:
            return '';
    }
}
